<template>
  <div class="notification-item-simple">
    <div class="notification-item-simple__container">
      <div class="notification-item-simple__icon">
        <img src="@/assets/icons/pending-large.svg" v-if="icon === 'pending'" />
        <img src="@/assets/icons/fail-icon-small.svg" v-if="icon === 'cancel'" />
      </div>
      <h4 class="notification-item-simple__title" v-if="title">{{ title }}</h4>
      <div
        v-if="showAutoCloseLoader"
        class="notification-item-simple__loader"
        :style="{ '--close-timeout': `${closeTimeout}ms` }"
      >
        <svg width="32" height="32" viewBox="0 0 32 32">
          <circle cx="16" cy="16" r="13" class="notification-item-simple__loader-ring" />
        </svg>
      </div>
      <button
        @click="onClose"
        v-show="closeButton"
        class="notification-item-simple__close"
      ></button>
    </div>
    <div class="notification-item-simple__container notification-item-simple__container--simple">
      <div class="notification-item-simple__text">
        {{ text }}
      </div>
    </div>
  </div>
</template>

<script src="./notification-item-simple.js"></script>
<style src="./notification-item-simple.scss" lang="scss"></style>
